import React from 'react';
import { motion } from 'framer-motion';
import { Sparkles, Flower2, Activity, Footprints, Users, Gift } from 'lucide-react';
const services = [{
  icon: Flower2,
  title: '精油按摩',
  subtitle: 'Aromatherapy Massage',
  desc: '融合天然精油，舒缓身心，通过芳香疗法达到深层放松。'
}, {
  icon: Sparkles,
  title: '泰式按摩',
  subtitle: 'Thai Massage',
  desc: '传统泰式手法，拉伸筋骨，释放压力，恢复身体活力。'
}, {
  icon: Activity,
  title: '深层组织按摩',
  subtitle: 'Deep Tissue',
  desc: '针对肌肉深层，缓解长期疲劳与肌肉酸痛，适合高压人群。'
}, {
  icon: Footprints,
  title: '足部按摩',
  subtitle: 'Foot Reflexology',
  desc: '足底穴位按摩，促进血液循环，改善睡眠质量。'
}, {
  icon: Users,
  title: '伴游服务',
  subtitle: 'Companion Services',
  desc: '专业陪伴，商务社交，为您提供高素质的社交伴侣。'
}, {
  icon: Gift,
  title: '定制服务',
  subtitle: 'Custom Package',
  desc: '根据您的具体需求，量身定制专属的放松体验方案。'
}];
export function Services() {
  return <section id="services" className="py-24 bg-[#faf7f2]" data-id="element-104">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-105">
        <div className="text-center mb-16" data-id="element-106">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-107">
            <h2 className="text-4xl md:text-5xl font-serif font-bold text-[#1a1a2e] mb-4" data-id="element-108">
              尊贵服务
            </h2>
            <p className="text-[#c9a96e] uppercase tracking-widest font-medium mb-2" data-id="element-109">
              Our Premium Services
            </p>
            <div className="w-24 h-1 bg-[#c9a96e] mx-auto mt-6" data-id="element-110" />
          </motion.div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-111">
          {services.map((service, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="group bg-white p-8 rounded-sm shadow-sm hover:shadow-xl transition-all duration-300 border border-gray-100 hover:border-[#c9a96e]/30" data-id="element-112">
              <div className="w-14 h-14 bg-[#1a1a2e] rounded-full flex items-center justify-center mb-6 group-hover:bg-[#c9a96e] transition-colors duration-300" data-id="element-113">
                <service.icon className="text-[#c9a96e] group-hover:text-white transition-colors duration-300" size={28} data-id="element-114" />
              </div>
              <h3 className="text-2xl font-serif font-bold text-[#1a1a2e] mb-1 group-hover:text-[#c9a96e] transition-colors" data-id="element-115">
                {service.title}
              </h3>
              <p className="text-sm text-gray-500 uppercase tracking-wide mb-4 font-medium" data-id="element-116">
                {service.subtitle}
              </p>
              <p className="text-gray-600 leading-relaxed" data-id="element-117">{service.desc}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}